<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4>
            </div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{ errors }}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{ key }}: {{ error }}
                </p>
            </div>
        </div>
        <br />
        <div class="mb-5">
            <label>Type:</label>
            <treeselect placeholder="Select Type" v-model="pmtaConfig.type" :multiple="false" :options="configTypeList"
                :load-options="loadConfigTypeList" @input="configTypeSelected" />

            <div v-if="$v.pmtaConfig.type.$error">
                <div class="text-danger" v-if="!$v.pmtaConfig.type.required">Type is required.</div>
            </div>
        </div>
        <div class="mb-5">
            <label>Config:</label>
            <treeselect placeholder="Select Config" v-model="pmtaConfig.id" :multiple="false" :options="configList" />
            <div v-if="$v.pmtaConfig.id.$error">
                <div class="text-danger" v-if="!$v.pmtaConfig.id.required">Config is required.</div>
            </div>
        </div>
        <div class="mb-5">
            <label>Recipient Owner:</label>
            <treeselect placeholder="Select" v-model="recipientOwner" :multiple="false" :options="userList"
                :load-options="loadUserList" @input="recipientOwnerSelected" :disabled="!pmtaConfig.id" />
        </div>
        <div class="mb-4">
            <label>Recipients:</label>
            <treeselect placeholder="Select Recipients" v-model="recipients" :multiple="true" :options="recipientList"
                value-format="object" />
            <div v-if="$v.recipients.$error">
                <div class="text-danger" v-if="!$v.recipients.required">Recipient is required</div>
            </div>
        </div>

        <div class="form-group text-center p-b-20  p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                    v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Treeselect from '@riophae/vue-treeselect';
import PmtaConfigService from '../../services/PmtaConfigService';
import PmtaRelayGroupService from '../../services/PmtaRelayGroupService';
import PmtaRelayService from '../../services/PmtaRelayService';
import PmtaServerService from '../../services/PmtaServerService';
import UserService from '../../services/UserService';

export default {
    name: 'AppliedPmtaConfigForm',
    components: { Treeselect },
    data() {
        return {
            pmtaConfig: {
                id: null,
                type: null,
            },
            configList: [],
            configTypeList: null,
            userList: null,
            recipientList: [],
            recipients: null,
            recipientOwner: null,
            groupList: [],
            errors: {},
            showFailureMessage: false,
            submitting: false,
        }
    },
    mounted() {
    },
    validations() {
        return {
            pmtaConfig: {
                id: { required },
                type: { required },
            },
            recipients: {required}
        }
    },
    methods: {
        onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.submitting = true;
            let rcpnts = [];
            if (this.pmtaConfig.type === 1) {//VMTA
                rcpnts = this.recipients.map((parent) => {
                    if (parent.hasOwnProperty('children')) {
                            return parent.children;
                    } else {
                        return parent;
                    }
                });
                rcpnts = rcpnts.flat();
            } else { //PMTA
                rcpnts = this.recipients;
            }

            PmtaConfigService.applyConfigTo(this.pmtaConfig, rcpnts).then(response => {
                if (response.status === 200) {
                    this.$router.push({ name: 'appliedPmtaConfigs' });
                }
                this.submitting = false;
                this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                this.showFailureMessage = true;
            }).catch(error => {
                this.submitting = false;
                this.errors = error.response.data.error;
                this.showFailureMessage = true;
            });
        },
        loadConfigTypeList({ callback }) {
            PmtaConfigService.getTypeList().then(response => {
                this.configTypeList = response.data.types.map((type, index) => {
                    return { id: index, label: type }
                });
                callback();
            });
        },
        configTypeSelected() {
            if (undefined === this.pmtaConfig.type) {
                this.configList = [];
                return;
            }
            PmtaConfigService.getPmtaConfigSelect(this.pmtaConfig.type).then(response => {
                this.configList = response.data['hydra:member'].map(pmtaConfig => {
                    return { id: pmtaConfig.id, label: pmtaConfig.name }
                });
            });
        },
        loadUserList({ callback }) {
            UserService.getUserSelect().then(response => {
                this.userList = response.data['hydra:member'].map(user => {
                    return { id: user.id, label: user.username }
                });
                callback();
            });
        },
        recipientOwnerSelected() {
            this.recipientList = [];
            switch (this.pmtaConfig.type) {
                case 0:
                    this.getPmtaServers();
                    break;
                case 1:
                    this.getPmtaRelays();
                    break;
            }
        },
        getPmtaServers() {
            PmtaServerService.getServerSelect(this.recipientOwner).then(response => {
                this.recipientList = response.data['hydra:member'].map(server => {
                    return { id: server.id, label: server.name }
                });
            });
        },
        getPmtaRelays() {
            PmtaRelayGroupService.getGroupSelect(this.recipientOwner).then(response => {
                this.groupList = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                this.groupList.map(group => {
                    PmtaRelayService.getRelaysByGroup(group.id).then(response => {
                        this.recipientList.push({
                            id: '_' + group.id,
                            label: group.label,
                            children: response.data['hydra:member'].map(relay => {
                                return { id: relay.id, label: relay.smtpHost }
                            })
                        });
                    });
                });
            });
        }
    }
}
</script>

<style scoped></style>
